
export const sampleSetter = (state, action) => {
  const { payload } = action;

  state.sample.raw = payload.raw;
  //state.sample.error = payload.error;
};

export const sampleGetter = (state, action) => { };